import { put, call, take, fork } from 'redux-saga/effects'
import { coursePatchService } from '../../api/course'
import { coursePatchSuccess } from '../../reducers/course/action'
import { COURSE_PATCH } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* coursePatchFlow(payload) {
  try {
    const { content, callback } = payload
    yield call(coursePatchService, content)

    yield put(coursePatchSuccess(content))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* coursePatchWatcher() {
  while (true) {
    const action = yield take(COURSE_PATCH)
    const { payload } = action

    yield fork(generalSaga, coursePatchFlow, payload)
  }
}
